<template>
  <!-- calss添加了一个样式 -->
  <div
    class="tagsbox"
    style="height: 46px; line-height: 38px; border-top: 1px solid #eee; overflow: auto; padding: 0; margin-top: 8px"
  >
    <div
      v-for="(item, index) in tags"
      :key="item.path"
      :class="{ active: isActive(item.path) }"
      class="tagsview"
      @click="tagsmenu(item)"
      @contextmenu.prevent="openMenu(item, $event)"
    >
      {{ filterTitle(item.title) }}
      <!-- 这个地方一定要click加个stop阻止，不然会因为事件冒泡一直触发父元素的点击事件，无法跳转另一个路由 -->
      <span class="el-icon-close tagsicon" @click.stop="handleClose(item, index)"></span>
      <ul v-show="visible && selectedTag === item" :style="menuStyle" class="contextmenu">
        <li @click.stop="handleClose(item, index)">关闭</li>
        <li @click.stop="cleartags($route.path)">关闭所有</li>
      </ul>
    </div>
    <el-dropdown class="tags-dropdown" trigger="click">
      <span class="el-dropdown-link">
        其它操作
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item icon="el-icon-circle-close" @click.native="cleartags($route.path)">关闭所有</el-dropdown-item>
        <el-dropdown-item icon="el-icon-close" @click.native="clearother($route)">关闭其它</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  //这个就是导入vuex的数据，配合下面...map用
  import { mapMutations, mapState } from "vuex";

  export default {
    name: "TagsView",
    data() {
      return {
        //右键菜单隐藏对应布尔值
        visible: false,
        selectedTag: null,
        menuStyle: {
          left: 0,
          top: 0
        }
      };
    },
    computed: {
      //引入vuex中state中的tags数据，一样this调用就行
      ...mapState(["tags"])
    },
    watch: {
      //监听右键菜单的值是否为true，如果是就创建全局监听点击事件，触发closeMenu事件隐藏菜单，如果是false就删除监听
      visible(value) {
        if (value) {
          document.body.addEventListener("click", this.closeMenu);
        } else {
          document.body.removeEventListener("click", this.closeMenu);
        }
      }
    },
    methods: {
      // 过滤 title 中的中英文括号及其内容
      filterTitle(title) {
        if (!title) return title;
        return title
          .replace(/\([^)]*\)/g, "")
          .replace(/（[^）]*）/g, "")
          .trim();
      },
      //引入vuex中mutation方法，可以直接this.xxx调用他
      ...mapMutations(["closeTab", "cleartagsview", "clearothertags"]),
      //点击叉叉删除的事件
      handleClose(item, index) {
        //先把长度保存下来后面用来比较做判断条件
        const length = this.tags.length - 1;
        //vuex调方法,上面...map引入的vuex方法，不会这种方法的看vue官网文档
        this.closeTab(item);
        // 如果关闭的标签不是当前路由的话，就不跳转
        if (item.path !== this.$route.path) {
          return;
        }
        // 判断：如果index和length是一样的，那就代表都是一样的长度，就是最后一位，那就往左跳转一个
        if (index === length) {
          //再判断：如果length=0，也就是说你删完了所有标签
          if (length === 0) {
            //那么再判断：如果当前路由不等于index，也就是我首页的路由
            if (this.$route.path !== "/home/workbench") {
              //那么就跳转首页。这一步的意思是：如果删除的最后一个标签不是首页就统一跳转首页，如果你删除的最后一个标签是首页标签，已经在这个首页路由上了，你还跳个什么呢。这不重复操作了吗。
              this.$router.push({ path: "/home/workbench" });
            }
          } else {
            //那么，如果上面的条件都不成立，没有length=0.也就是说你还有好几个标签，并且你删除的是最后一位标签，那么就往左边挪一位跳转路由
            this.$router.push({ path: this.tags[index - 1].path });
          }
        } else {
          // 如果你点击不是最后一位标签，点的前面的，那就往右边跳转
          this.$router.push({ path: this.tags[index].path });
        }
      },
      //点击跳转路由
      tagsmenu(item) {
        // Always update the active tag and route
        this.$router.push({ path: item.path });
        // Update the active state in Vuex
        this.$store.commit("setActive", item.path);
      },
      //通过判断路由一致返回布尔值添加class，添加高亮效果
      isActive(route) {
        return route === this.$route.path;
      },
      //右键事件，显示右键菜单，并固定好位置。
      openMenu(tag, e) {
        this.visible = true;
        this.selectedTag = tag;
        const offsetLeft = this.$el.getBoundingClientRect().left;
        this.menuStyle = {
          left: `${e.clientX - offsetLeft + 210}px`,
          top: `${e.clientY + 10}px`
        };
      },
      //隐藏右键菜单
      closeMenu() {
        this.visible = false;
        this.selectedTag = null;
      },
      //右键菜单关闭所有选项，触发vuex中的方法，把当前路由当参数传过去用于判断
      cleartags(val) {
        this.cleartagsview(val);
      },
      //关闭其他
      clearother(val) {
        this.clearothertags(val);
      }
    },
    beforeDestroy() {
      document.body.removeEventListener("click", this.closeMenu);
    }
  };
</script>

<style lang="scss" scoped>
  //标签导航样式
  .tagsbox {
    height: 46px;
    line-height: 38px;
    border-top: 1px solid #eee;
    overflow: auto;
    padding: 0;
    margin-top: 8px;
  }

  //标签导航样式
  .tagsview {
    cursor: pointer;
    margin-right: 4px;
    height: 32px;
    line-height: 32px;
    padding: 0 8px;
    border: 1px solid #d8dce5;
    border-radius: 4px;
    color: #606266;
    font-size: 13px;
    display: inline-block;
    margin-bottom: 10px;
    background-color: #fff;
    position: relative;
    transition: padding-right 0.3s;

    &:hover {
      padding-right: 24px;
    }
  }

  //叉号样式
  .tagsicon {
    position: absolute;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
    display: none;
    font-size: 12px;

    &:hover {
      color: #2e82ff;
    }
  }

  //标签hover时显示叉号
  .tagsview:hover .tagsicon {
    display: inline-block;
  }

  //标签高亮
  .active {
    background-color: #2e82ff;
    color: #fff;
  }

  //右键菜单样式
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 100;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);

    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;

      &:hover {
        background: #eee;
      }
    }
  }

  .tags-dropdown {
    float: right;
    cursor: pointer;

    .el-dropdown-link {
      font-size: 15px;
      color: #2c3e50;
      margin-right: 2px;

      .el-icon--right {
        font-size: 15px;
      }
    }
  }
</style>
